import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ClienteEntity } from "@catalogo/models";
import { CONFIGURACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class ClienteDataService extends CrudService<ClienteEntity>
{
    protected url: string;

    constructor(
        @Inject(CONFIGURACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    )
    {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/cliente`;
    }
}
